import { css } from '@emotion/react'
import styled from '@emotion/styled'

import Info from './icons/Info'

const Banner = styled.div<{ isAdornmentPresent: boolean }>`
	display: inline-block;
	max-width: 100%;
	white-space: break-spaces;
	margin-top: ${({ theme }) => theme.spaces.space7};
	border-radius: ${({ theme }) => theme.borderRadiuses.xl};
	background-color: ${({ theme }) => theme.colors.light.surfaceDecorative};
	padding: ${({ theme }) => (theme.isMobile ? theme.spaces.space4 : theme.spaces.space6)};
	${({ isAdornmentPresent }) =>
		isAdornmentPresent &&
		css`
			padding: 0;
		`}
`

const StyledInfoIcon = styled(Info)<{ isAdornmentPresent: boolean }>`
	${({ isAdornmentPresent, theme }) =>
		isAdornmentPresent &&
		css`
			margin-left: ${theme.spaces.space4};
			margin-top: ${theme.spaces.space4};
		`}
`

const BannerInner = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: center;
	gap: ${({ theme }) => theme.spaces.space4};
	border-radius: inherit;
`

const Title = styled.h3`
	${({ theme }) => theme.typography.paragraphMedium};
	margin-top: 3px;
	margin-bottom: ${({ theme }) => theme.spaces.space4};
`

const Paragraph = styled.p`
	margin: auto;
	${({ theme }) => (theme.isMobile ? theme.typography.caption : theme.typography.paragraph)};

	a {
		color: ${({ theme }) => theme.colors.light.primaryTextColor};
	}
`

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
`

type Props = {
	children: React.ReactNode
	rightAdornment?: React.ReactNode
	title?: string
}

function InfoBanner({ children, rightAdornment, title, ...restProps }: Props) {
	const isAdornmentPresent = Boolean(rightAdornment)
	const isTitlePresent = Boolean(title)

	return (
		<Banner isAdornmentPresent={isAdornmentPresent} {...restProps}>
			<BannerInner>
				<StyledInfoIcon isAdornmentPresent={isAdornmentPresent} />
				<ContentWrapper>
					{isTitlePresent && <Title>{title}</Title>}
					<Paragraph>{children}</Paragraph>
				</ContentWrapper>
				{rightAdornment}
			</BannerInner>
		</Banner>
	)
}

export default InfoBanner
